import * as React from 'react';
import styled from 'styled-components';
import { DSTypography } from '../../mui';

const StyledWrapper = styled.div`
    display: flex;
    flex-direction: column;
`;

interface BoxProps {
    colour: string;
}

const StyledBox = styled.div`
    flex-grow: 0;
    flex-shrink: 0;

    width: 20px;
    height: 20px;

    margin-top: 5px;
    margin-right: 10px;

    // Important forces this to render when printing
    background-color: ${(props: BoxProps) => props.colour} !important;
`;

const StyledRowWrapper = styled.div`
    display: flex;
    flex-direction: row;
`;

const StyledTitleWrapper = styled.div`
    ${props =>
        typeof props.onClick !== 'undefined'
            ? `
                cursor: pointer; 
            `
            : ''}
`;

type ReportLabel = {
    title: string;
    description?: string;
    colour: string;
    onClick?: () => void;
};

export function toReportLabels<T>(
    obj: T[] | null | undefined,
    mappingFunc: (data: T, index: number) => ReportLabel,
): ReportLabel[] | undefined {
    return obj ? obj.map(mappingFunc) : undefined;
}

type ReportLabelsProps = {
    labels?: ReportLabel[];
};

export const ReportLabels: React.FunctionComponent<ReportLabelsProps> = ({ labels }) => (
    <StyledWrapper>
        {labels?.map(label => (
            <StyledRowWrapper key={label.title}>
                <StyledBox colour={label.colour} />
                <StyledTitleWrapper onClick={label.onClick}>
                    <DSTypography variant="h4">{label.title}</DSTypography>
                    {label.description && <DSTypography>{label.description}</DSTypography>}
                </StyledTitleWrapper>
            </StyledRowWrapper>
        ))}
    </StyledWrapper>
);
ReportLabels.displayName = 'ReportLabels';
